import { useTranslation } from '@mc/i18n'
import { Beta } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { SubcategoryWithOutcome } from '../../../../types/data'
import { ArticleTile } from './ArticleTile'

export const ArticleCarousel = () => {
  const { t } = useTranslation('@mc/next')

  const { subcatToOutcomes } = useStaticData<{
    subcatToOutcomes: SubcategoryWithOutcome
  }>()

  return (
    <div className='container mc-mt-10 mc-mb-12'>
      <Beta.CarouselModern
        title={
          <p className='mc-text-h2 mc-mb-4'>
            {t('subcategoryPage.articleCarousel.title')}
          </p>
        }
        srLabel='instructor carousel'
        className='row'
        arrowCls='d-none d-sm-block'
        pagesCls='d-none d-sm-block'
        noPages
      >
        {subcatToOutcomes.articles.map((article, colIdx) => (
          <ArticleTile key={article.slug} article={article} colIdx={colIdx} />
        ))}
      </Beta.CarouselModern>
    </div>
  )
}
